import { render, staticRenderFns } from "./CodigoCerti.vue?vue&type=template&id=2b1ff3db"
import script from "./CodigoCerti.vue?vue&type=script&lang=js"
export * from "./CodigoCerti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports